export class UserConfigModel{

	scannerDevice: string = 'C';
}
